export class PromotionsModel {  
    public id: string
    public namePromotion: string
    public valuePromotion: number
    public dateToPromotion: string 
    public promotionOnlyOneUse: boolean
    public isUsed: boolean
}